module.exports = __webpack_public_path__ + "ProfileHeader.d1ca340.png";